import { ApiClient } from './api-client';
import { 
  AdminKPIStats, 
  AdminProspectItem, 
  SharedSiretGroup, 
  ApporteurDirectoryItem,
  AdminUserItem,
  CreateUserDTO,
  UpdateUserDTO
} from '../types';

export interface AdminProspectFilterQuery {
  sortBy?: 'date' | 'apporteur' | 'size' | 'siret';
  order?: 'asc' | 'desc';
  filterApporteur?: string;
  filterSize?: string;
  search?: string;
}

export class AdminApi {
  public static async getStats(): Promise<AdminKPIStats> {
    return ApiClient.request<AdminKPIStats>('/api/admin/stats');
  }

  public static async getProspects(query: AdminProspectFilterQuery = {}): Promise<AdminProspectItem[]> {
    const params = new URLSearchParams();
    if (query.sortBy) params.set('sortBy', query.sortBy);
    if (query.order) params.set('order', query.order);
    if (query.filterApporteur) params.set('filterApporteur', query.filterApporteur);
    if (query.filterSize) params.set('filterSize', query.filterSize);
    if (query.search) params.set('search', query.search);

    return ApiClient.request<AdminProspectItem[]>(`/api/admin/prospects?${params.toString()}`);
  }

  public static async getSharedSirets(): Promise<SharedSiretGroup[]> {
    return ApiClient.request<SharedSiretGroup[]>('/api/admin/shared-sirets');
  }

  public static async getApporteurs(): Promise<ApporteurDirectoryItem[]> {
    return ApiClient.request<ApporteurDirectoryItem[]>('/api/admin/apporteurs');
  }

  public static async getUsers(role?: string, search?: string, status?: string): Promise<AdminUserItem[]> {
    const params = new URLSearchParams();
    if (role && role !== 'all') params.set('role', role);
    if (status && status !== 'all') params.set('status', status);
    if (search?.trim()) params.set('search', search.trim());
    return ApiClient.request<AdminUserItem[]>(`/api/admin/users?${params.toString()}`);
  }

  public static async validateUser(id: number): Promise<{ success: boolean; message: string; user: AdminUserItem }> {
    return ApiClient.request<{ success: boolean; message: string; user: AdminUserItem }>(`/api/admin/users/${id}/validate`, {
      method: 'POST'
    });
  }

  public static async rejectUser(id: number): Promise<{ success: boolean; message: string; user: AdminUserItem }> {
    return ApiClient.request<{ success: boolean; message: string; user: AdminUserItem }>(`/api/admin/users/${id}/reject`, {
      method: 'POST'
    });
  }

  public static async getUserById(id: number): Promise<AdminUserItem> {
    return ApiClient.request<AdminUserItem>(`/api/admin/users/${id}`);
  }

  public static async createUser(data: CreateUserDTO): Promise<AdminUserItem> {
    return ApiClient.request<AdminUserItem>('/api/admin/users', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  public static async updateUser(id: number, data: UpdateUserDTO): Promise<AdminUserItem> {
    return ApiClient.request<AdminUserItem>(`/api/admin/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  public static async resetPassword(id: number, password: string): Promise<{ success: boolean; message: string }> {
    return ApiClient.request<{ success: boolean; message: string }>(`/api/admin/users/${id}/reset-password`, {
      method: 'POST',
      body: JSON.stringify({ password })
    });
  }

  public static async deleteUser(id: number): Promise<{ success: boolean; message: string }> {
    return ApiClient.request<{ success: boolean; message: string }>(`/api/admin/users/${id}`, {
      method: 'DELETE'
    });
  }
}
